<template>
  <div class="discounts-section px-6 py-8 md:pt-10 md:pl-16 md:pr-12 xl:pl-32 text-left">
    <div class="flex mb-4 md:mb-8">
      <!-- Discount Icon -->
      <div
        v-if="content.icon.isIcon"
        class="discounts-section__icon bg-primary-light w-14 h-14 rounded-full flex flex-shrink-0"
        v-dompurify-html:svg="iconSource"
      />

      <img
        v-else
        :alt="content.icon.alt"
        :src="content.icon.source"
        class="discounts-section__image"
      />

      <div class="ml-4 md:ml-6">
        <!-- Title -->
        <h6 class="mb-1 md:mb-2 text-2xl text-black-darkest tracking-0.15px">
          {{ content.title }}
        </h6>

        <!-- Description -->
        <div v-dompurify-html="content.description" class="richtext"></div>
      </div>
    </div>

    <!-- Discounts -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <DiscountCard
        v-for="(discount, index) of content.discounts"
        :key="index"
        :discount="discount"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DiscountCard from '@/components/molecules/DiscountCard/index.vue'
import { DiscountsSection } from '@/model'
import useRemoteIcon from '@/hooks/useRemoteIcon'

export default defineComponent({
  components: {
    DiscountCard
  },
  props: {
    content: {
      type: Object as () => DiscountsSection,
      required: true,
      validator: (value: DiscountsSection) => value instanceof DiscountsSection
    }
  },
  setup (props) {
    const iconSource = props.content.icon.isIcon && props.content.icon.source
      ? useRemoteIcon(props.content.icon.source)
      : null

    return { iconSource }
  }
})
</script>

<style>
.discounts-section {
  &__icon svg {
    @apply w-8 h-8 m-auto fill-current text-primary; 
  
  }

  &__image {
    @apply w-14 h-14;
  }
}
</style>
